import { defineAction } from '~/prix'
import { z } from 'zod'
import materialDeliveryDocumentUpdateAction from './materialDeliveryDocumentUpdate.action.json' with { type: 'json' }
import { materialDeliveryDocumentObject } from '../materialDeliveryDocumentObject'

const materialDeliveryDocumentUpdateDefinition = defineAction({
  ...materialDeliveryDocumentUpdateAction,
  input: materialDeliveryDocumentObject
    .pick({
      id: true,
      fileName: true,
      mimeType: true,
      status: true,
    })
    .partial({ fileName: true, mimeType: true, status: true }),
  output: z.object({}),
})

export default materialDeliveryDocumentUpdateDefinition
